export const EXPORT_EXCEL_CONFIG = {
  LIMIT: 100, // fetch 100 items per page for export
};
